import React from 'react'
import Header from './header'
import { any } from 'prop-types'
import styled from 'styled-components'
import { frontTheme } from '../../components/layout_user/index'
import { ThemeProvider } from '@material-ui/core'

const Styled = styled.div`
  background: #fff;
  min-height: 100vh;
`

const LayoutMicro = props => {
  return (
    <ThemeProvider theme={frontTheme}>
      <Styled>
        <Header />
        {props.children}
      </Styled>
    </ThemeProvider>
  )
}

LayoutMicro.propTypes = {
  children: any
}

export default LayoutMicro
